import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const ORIGIN = "https://positiverecruitment.io";

// Sekcje prywatne / niepubliczne - nie chcemy dla nich alternatywnych wersji językowych.
const PRIVATE_PREFIXES = ["/crm", "/portal"];

/**
 * Emituje tagi hreflang (pl / en / x-default) dla bieżącej trasy.
 * Wersje językowe rozróżniane są parametrem ?lang=, który jest odczytywany
 * przez detektor języka i18next.
 */
const Hreflang = () => {
  const { pathname } = useLocation();

  if (PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }

  // Artykuly Insights emituja wlasne alternatywy jezykowe w ArticleSeo.
  if (pathname.startsWith("/insights/")) {
    return null;
  }


  const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
  const base = `${ORIGIN}${path}`;

  return (
    <Helmet>
      <link rel="alternate" hrefLang="pl" href={base} />
      <link rel="alternate" hrefLang="en" href={`${base}?lang=en`} />
      <link rel="alternate" hrefLang="zh-Hans" href={`${base}?lang=zh`} />
      <link rel="alternate" hrefLang="x-default" href={base} />
    </Helmet>
  );
};

export default Hreflang;
